import { useMeetingSelector } from "@kalyzee/kast-web-sdk";
import React, { useRef } from "react";
import { CircleIcon, PrimaryButton } from "@kalyzee/kalyzee-ui";
import { useSdkContext } from "../../contexts/sdk/context";
import { useRefAutoUpdate } from "@kalyzee/kast-web-sdk/web-components";
import { MeetingSessionHighlightingState } from "@kalyzee/kast-web-sdk/websocket";
import { toastError } from "../../helpers/toast";
import OverlayInformationMessage from "../utils/OverlayInformationMessage";
import { useFeatures } from "../../hooks/features";
import { useMeetingContainerContext } from "../../contexts/meetingContainer/context";

export const HighlightButton = React.memo(({ onRequestHighlight }: { onRequestHighlight?: () => void }) => {
  const { containerAPI } = useMeetingContainerContext();

  const [session] = useMeetingSelector(containerAPI, "session");
  const sdkCtx = useSdkContext();
  const sdkCtxRef = useRefAutoUpdate(sdkCtx);
  const features = useFeatures();
  const currRef = useRef<HTMLDivElement>(null);

  if (!session) return null;

  // Feature disable but if i am invited to the board, there i go, and i see the button to stop
  if (!features.board && session.highlighting === MeetingSessionHighlightingState.INACTIVE) return null;

  const renderButton = () => {
    const permitted = !(session?.permissions?.highlighting === false);
    let hoverMessage: string | undefined = undefined;
    if (!permitted) hoverMessage = "Vous ne pouvez actuellement pas monter au tableau";
    return (
      <div ref={currRef} key="student-dashboard-overlay-raise-hand-btn">
        <PrimaryButton
          onClick={async () => {
            const client = sdkCtxRef.current.client.getWebsocketClient();
            if (!client || !session) return;
            if (session.highlighting === MeetingSessionHighlightingState.INACTIVE) {
              if (onRequestHighlight) {
                onRequestHighlight();
              } else {
                const response = await client.emitter.meeting.requestForHighlighting({
                  sessionId: session.id,
                });
                if (response.error || !response.response) {
                  toastError("Une erreur est survenue...");
                }
              }
            } else {
              const response = await client.emitter.meeting.stopHighlighting({
                sessionId: session.id,
              });
              if (response.error || !response.response) {
                toastError("Une erreur est survenue...");
              }
            }
          }}
        >
          <CircleIcon.Variants.RaiseHand
            unavailable={!permitted}
            state={session.highlighting === MeetingSessionHighlightingState.PENDING_REQUEST ? "pending" : session.highlighting === MeetingSessionHighlightingState.ONGOING ? "ongoing" : "inactive"}
          />
        </PrimaryButton>
        {hoverMessage ? <OverlayInformationMessage targetRef={currRef} message={hoverMessage} /> : null}
      </div>
    );
  };

  return renderButton();
});